/**
 * Billing money helpers. IEEE-754 cannot represent rates like 0.14 exactly,
 * so `0.14 * 100` becomes `14.000000000000002`. Always go through these
 * when displaying or totaling tax.
 */

export function roundToCents(amount: number): number {
    return Number(`${Math.round(Number(`${amount}e2`))}e-2`);
}

/**
 * Canadian sales-tax percentages use at most 3 decimal places (Quebec 14.975%).
 * Rounding to 4 decimal places strips float noise without changing real rates.
 */
export function normalizeTaxPercent(percent: number): number {
    return Number.parseFloat(percent.toFixed(4));
}

export function formatTaxPercent(percent: number): string {
    return `${normalizeTaxPercent(percent)}%`;
}

export function taxOnAmount(amount: number, taxPercent: number): number {
    return roundToCents(amount * (normalizeTaxPercent(taxPercent) / 100));
}
